<template>
  <div>
    <h3>Saved Codes:</h3>
    <ul>
      <li v-for="(item, index) in savedCode" :key="index">
        {{ item.date }}
        <button class="mx-2" @click="$emit('edit-code', index)">Edit</button>
        <button class="mx-2" @click="$emit('delete-code', index)">Delete</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedCode: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
/* Add any custom styles for the saved code list component */
</style>
